export default "__VITE_ASSET__CgzD6Si5__"